import React, {useState} from 'react'

import TradeStates from './states/TradeStates'
import AlgoStates from './states/AlgoStates'
import TriggerStates from './states/TriggerStates'

import useTriggerStore from "../../stores/TriggersStore"
import useTradeStore from "../../stores/TradesStore"
import  useAlgoStore  from '../../stores/AlgosStore'

function MobileMyOrders() {
  const [selectedTab, setSelectedTab] = useState(process.env.REACT_APP_TRADE_FIRST ? "trade" : "algo")
  const algoCount = useAlgoStore((state) => state.algo_count)
    const tradeCount = useTradeStore((state) => state.trade_count)
    const triggerCount = useTriggerStore((state) => state.trigger_count)
  return (
    <div className='mobile_container'>
      <ul className="mobile_tab_nav">
          <li className={selectedTab === "algo" ? "active_widget_tab li": "li"} onClick={()=> setSelectedTab("algo")}><span>algos {algoCount !== 0 ? <div className='state_count'>{algoCount} </div>: null}</span></li>
          <li className={selectedTab === "trade" ? "active_widget_tab li": "li"}  onClick={()=> setSelectedTab("trade")}><span>trades{tradeCount !== 0 ? <div className='state_count' >{tradeCount}</div> : null}</span></li>
          <li className={selectedTab === "trigger" ? "active_widget_tab li": "li"}  onClick={()=> setSelectedTab("trigger")}><span>triggers{triggerCount !== 0 ? <div className='state_count no_drag'>{triggerCount} </div>: null}</span></li>
      </ul>
      { renderTabContent(selectedTab)}
    </div>
  )
}

export default MobileMyOrders

function renderTabContent(selectedTab) {
  switch (selectedTab) {
      case 'trade':
          return <TradeStates />;
      case 'algo':
          return <AlgoStates />;
      case 'trigger':
          return <TriggerStates />;
      default:
          return null;
  }
}